<ng-template>
	<div
		(@transformPopover.done)="_onAnimationDone($event)"
		[@transformPopover]="{ value: state, params: params }"
		[ngClass]="_classList"
		#focusTrapElement
		class="sat-popover-container"
	>
		<mat-card class="mat-elevation-z6 flex flex-col">
			<mat-form-field
				appearance="fill"
				class="mat-form-field-no-hint mat-form-field-compact mat-form-field-plain w-full"
			>
				<mat-icon matPrefix>search</mat-icon>
				<input
					[formControl]="search"
					[placeholder]="'reports.filter.tasksearch' | translate"
					matInput
					type="text"
				>
				<button
					(click)="search.setValue('')"
					*ngIf="search?.value"
					mat-icon-button
					matSuffix
				>
					<mat-icon>clear</mat-icon>
				</button>
			</mat-form-field>
			<div class="mt-1 flex flex-row items-center justify-start gap-2">
				<div class="!ml-auto flex flex-row items-center justify-start">
					<div
						(click)="this.selectAll()"
						class="cursor-pointer p-2 text-sm font-bold"
						translate
					>
						reports.toggles.all
					</div>
					<div
						(click)="this.selectNone()"
						class="cursor-pointer p-2 text-sm font-bold"
						translate
					>
						reports.toggles.none
					</div>
				</div>
			</div>
			<div class="-mx-16px"><mat-divider inset></mat-divider></div>
			<mat-list class="-mx-16px pt-0">
				<cdk-virtual-scroll-viewport
					[itemSize]="48"
					class="h-64"
				>
					<mat-list-item
						(click)="$event.preventDefault(); $event.stopPropagation(); this.selectItem(item.id)"
						(keydown.enter)="$event.preventDefault(); $event.stopPropagation(); this.close()"
						(keydown.space)="$event.preventDefault(); $event.stopPropagation(); this.selectItem(item.id)"
						*cdkVirtualFor="let item of items$filtered.value$ | async; trackBy: trackId"
						class="cursor-pointer"
						matRipple
					>
						<div class="flex-mw flex flex-row items-center justify-start gap-2">
							<mat-checkbox
								[checked]="item.selected"
								class="mat-checkbox-flex"
								color="primary"
							></mat-checkbox>
							<div class="flex flex-col truncate">
								<span
									[matTooltip]="item.name"
									[matTooltipDisabled]="item.name.length <= 30"
									class="mat-truncate"
									>{{
										item.name
									}}</span
								>
								<div
									*ngIf="item.project | projectProxy as prj"
									class="mat-truncate mat-hint flex items-center space-x-2 text-sm leading-none"
								>
									<span
										[matTooltip]="prj.client | defaultEntityTranslate: 'client' : 'client.none' "
										>{{
											prj | defaultEntityTranslate: 'project' : 'project.none'
										}}</span
									>
								</div>
							</div>
						</div>
						@if(item.estimation > 0) {
						<div class="ml-auto">
							<app-estimation-statistics-graph
								[completed]="item.completed"
								[estimation]="item.estimation || 0"
								[recorded]="getTaskRecordedTime(item)"
								class="mb-1 justify-end"
							></app-estimation-statistics-graph>
						</div>
						}
					</mat-list-item>
				</cdk-virtual-scroll-viewport>
			</mat-list>
		</mat-card>
	</div>
</ng-template>
